import MarketsSvc from "./markets/marketsSvc";
import store from "Store";

const Locale = (() => {
  const svc = {
    localeMap: {
      "en-AE": "en-UE",
      "ar-AE": "ar-UE"
    },
    countryMap: {
      "AE": "UE",
    },
    translationLocaleMap: locale => {
      let mappedLocale = svc.localeMap[locale];
      if (mappedLocale) {
        return mappedLocale;
      } else {
        return locale;
      }
    },
    translationCountryMap: country => {
      let mappedCountry = svc.countryMap[country];

      if (mappedCountry) {
        return mappedCountry;
      } else {
        return country;
      }
    },
    getLangOptions: (markets, country) => {
      let marketDefinition = MarketsSvc.getMarketByCode(markets, country);
      let langOptions = (typeof(marketDefinition.languages) !== 'undefined') ? marketDefinition.languages.slice() : [];
      return langOptions;
    }
  };

  const publicMethods = {
    getDefaultLanguage: (markets, country) => {
      let marketDefinition = MarketsSvc.getMarketByCode(markets, country);
      let language = (typeof(marketDefinition.languages) !== 'undefined') ? marketDefinition.languages[0].code : undefined;
      return language;
    },
    createLocale: (country, language) => {
      return language + "-" + country;
    },
    updateLanguage: (language, State) => {
      let state = State();
      //return new locale
      return language + "-" + state.locale.country;
    },
    parseLocale: locale => {
      let localeArr = locale.split();
      return { language: localeArr[0], country: localeArr[1] };
    },
    getTranslationLocale: locale => {
      return svc.translationLocaleMap(locale);
    },
    getTranslationCountry: locale => {
      return svc.translationCountryMap(locale);
    },
    getLangOptions: (markets, country) => {
      return svc.getLangOptions(markets, country);
    },
    getTranslateText: key => {
      return store.getState().locale.translations[key] ? store.getState().locale.translations[key] : key;
    }
  };
  return publicMethods;
})();
export default Locale;



// WEBPACK FOOTER //
// ./src/services/locale.js